import Image from "@/atoms-react/image/Image.react";
import { Base, SectionTitle } from "@/atoms-react/text/Text.react";
import { useTranslation, Trans } from "react-i18next";
import { Button } from "@/atoms-react/button/Button.react";

type IdentificationFailedProps = {
  onValidated?: () => void;
};

export const IdentificationFailed = ({ onValidated = () => {} }: IdentificationFailedProps) => {
  const { t } = useTranslation(["atoms"]);
  return (
    <>
      <div className="mx-auto max-w-4xl px-4 py-4 text-center">
        <Image
          className="mx-auto mb-4 h-auto w-60 md:w-80"
          alt={t("molecules.modal_kyc_identity.step3_image_alt_error")}
          src={"/images/olkypass/validationKycError.svg"}
        />
        <div className="mx-auto px-4 text-center">
          <SectionTitle className="mb-4 text-base">
            {t("molecules.modal_kyc_identity.step3_title_error")}
          </SectionTitle>
          <Base className="font-medium text-gray-400">
            <Trans
              i18nKey={"molecules.modal_kyc_identity.step3_content_error"}
              ns={"atoms"}
              components={{ span: <span className="font-semibold text-primary" /> }}
            />
          </Base>
        </div>
      </div>
      <div className={"flex justify-end"}>
        <Button dataCy="confirm-button" className={"h-10 w-fit font-medium"} onClick={onValidated}>
          {t("molecules.modal_kyc_identity.continue")}
        </Button>
      </div>
    </>
  );
};
